import { swal } from '@/lib/sweetalert';

/**
 * デザインシェア用のURLを生成する
 */
export const createDesignShareUrl = (shareToken: string): string => {
  return `${process.env.NEXT_PUBLIC_BASE_URL}/design/${shareToken}`;
};

/**
 * シェア用URLをクリップボードにコピーする
 * @param url - シェア用URL
 * @returns 成功したかどうか
 */
export const copyToClipboard = async (url: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(url);
    await swal.toastSuccess({ title: 'シェア用URLをコピーしました' });
    return true;
  } catch {
    await swal.alert({ text: 'シェア用URLのコピーに失敗しました' });
    return false;
  }
};
